import z from "zod";
import { getUuid } from "../utils";
import { API } from "./api";
import { JSONBody } from "./general";
import { convertTimelapse, Timelapse } from "./timelapse";

export interface Area {
  id: number;
  scannerId: number;
  width: number;
  height: number;
  offsetX: number;
  offsetY: number;
  intervalS: number;
  timelapse?: Timelapse;
}

export const convertArea = (a: API.Area): Area => {
  return {
    id: a.id,
    scannerId: a.scanner_id,
    width: a.width,
    height: a.height,
    offsetX: a.offset_x,
    offsetY: a.offset_y,
    intervalS: a.interval_s,
    timelapse: a.timelapse ? convertTimelapse(a.timelapse) : undefined
  };
}
export const convertAreas = (a: API.Area[]): Area[] => {
  return a.map(convertArea).sort((a, b) => a.id - b.id);
}

// Schema

export const convertAreaSchema = (a: Area): AreaSchema => {
  return {
    id: a.id,
    iid: getUuid(),
    width: a.width,
    height: a.height,
    offsetX: a.offsetX,
    offsetY: a.offsetY,
    intervalS: a.intervalS,
  }
}

export const areaSchema = z.object({
  id: z.number().optional(),
  iid: z.string(), // Internal id required for the form
  width: z.number().positive(),
  height: z.number().positive(),
  offsetX: z.number().nonnegative(),
  offsetY: z.number().nonnegative(),
  intervalS: z.number().nonnegative(),
});
export type AreaSchema = z.infer<typeof areaSchema> & JSONBody;
